import { useCallback, useEffect } from "react";
import { usePopAlert2Context } from "components/popAlert/context/PopAlert2Context";
import { useLocation } from "react-router-dom";

function usePopAlert2() {
  const { state, action } = usePopAlert2Context();
  const { showAlert2, showConfirm2, confirm, cancel, hideAlert } = action;
  const { pathname } = useLocation();

  const onConfirm = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        e.stopPropagation();
        confirm();
      }
    },
    [confirm]
  );

  const onCancel = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        e.stopPropagation();
        cancel();
      }
    },
    [cancel]
  );

  return {
    state,
    showAlert2,
    showConfirm2,
    onConfirm,
    onCancel,
  };
}

export default usePopAlert2;
